module.exports = __webpack_public_path__ + "media/img/archi-13-d0406429.png";